import React from 'react';
import './biz-avatar.scss';
import { getPathWSiteRoot } from '../../Services/common';

type BizAvatarProps = {
	photo?: string;
	initials?: string;
	name?: string;
};

const BizAvatar = ({ photo, initials, name }: BizAvatarProps) => {
	const getInitials = () => {
		if (initials) {
			return initials;
		}
		if (name) {
			return name
				.split(' ')
				.map((n) => n[0])
				.join('')
				.substring(0, 2)
				.toUpperCase();
		}

		return 'NA';
	};

	const getAvatar = () => {
		if (photo) {
			return <img src={getPathWSiteRoot(photo)} />;
		}
		return <span>{getInitials()}</span>;
	};

	const getSizeClass = () => {
		return 'small'; //default, but prepared for more sizes
	};

	const classes = `biz-avatar ${getSizeClass()}`;

	return <div className={classes}>{getAvatar()}</div>;
};

export default BizAvatar;
